import { useEffect, useState } from "react";
import { listSalesDeskDeals, type SalesDeskDealRow } from "./salesDeskDeals";
import { salesDeskFulfillmentFromHint, salesDeskOrderCustomer, salesDeskSaleStatusLabel } from "./salesDeskOrderFilter";
import { salesDeskSaleIsClosed, type SalesDeskPerformanceRow } from "./salesDeskPerformanceCounts";

export function salesDeskPerformanceRow(deal: SalesDeskDealRow): SalesDeskPerformanceRow {
  const closed = salesDeskSaleIsClosed(deal.status);
  const serial = deal.serial?.trim() || null;
  return {
    id: deal.id,
    customer: salesDeskOrderCustomer(deal.displayName, deal.id),
    model: deal.productName.trim(),
    serial,
    office: deal.officeName.trim(),
    salesperson: deal.salespersonName.trim(),
    saleStatus: salesDeskSaleStatusLabel(deal.status),
    fulfillment: salesDeskFulfillmentFromHint(deal.eventHint),
    createdAt: deal.createdAt,
    updatedAt: deal.updatedAt,
    onLot: Boolean(serial) && !closed,
    closed,
  };
}

export function useSalesDeskPerformance(): {
  rows: SalesDeskPerformanceRow[];
  loading: boolean;
  error: string | null;
} {
  const [rows, setRows] = useState<SalesDeskPerformanceRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await listSalesDeskDeals();
      if (cancelled) return;
      if (!result.ok) {
        setError(result.error);
        setRows([]);
        setLoading(false);
        return;
      }
      setRows(result.deals.map(salesDeskPerformanceRow));
      setError(null);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { rows, loading, error };
}
